import React, { FC } from 'react';
import { RouteComponentProps, withRouter, Redirect } from 'react-router-dom';
import Button from '../../Shared/Button/Button';
import styles from './MaintenanceTriggerForm.module.scss';

type Props = {
  disabled: boolean;
  isUpdate: boolean;
  isLoading: boolean;
  finished: boolean;
  onCreate: () => void;
  onUpdate: () => void;
};

type ButtonProps = {
  type: 'submit' | 'button' | 'reset' | undefined;
  disabled: boolean;
  className: string;
  isLoading: boolean;
};

export const FormActions: FC<RouteComponentProps & Props> = ({ history, finished, disabled, isUpdate, isLoading, onCreate, onUpdate }) => {
  const commonButtonProps: ButtonProps = {
    disabled,
    className: styles.submitButton,
    type: 'submit',
    isLoading
  };

  const getButton = () => {
    if (isUpdate) {
      return <Button title='Update' onClick={onUpdate} {...commonButtonProps} />;
    }

    return <Button title='Create' onClick={onCreate} {...commonButtonProps} />;
  };

  if (finished) {
    return <Redirect to='/maintenance-triggers' />;
  }

  return <div className={styles.formActions}>{getButton()}</div>;
};

export default withRouter(FormActions);
